const baseURL = '/credits';
const pgURL = '/pg/nice';

const getData = R.prop('data');

const purchaseCreditsByWire = (reqBody) =>
    axios.post(`${baseURL}/transfers`, reqBody).then(getData);

const purchaseCreditsByCard = (reqBody) =>
    axios.post(`${baseURL}`, reqBody).then(getData);

const uploadBusinessNoFile = (formData) =>
    axios.post(`${baseURL}/business_number_file`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

const deleteBusinessNoFile = (key) =>
    axios.delete(`${baseURL}/business_number_file`, { data: { key } });

const getCreditsHistories = ({ page }) =>
    axios.get(`${baseURL}/histories`, { params: { page } }).then(getData);

const getPgPrepared = ({ EdiDate, Amt }) =>
    axios.post(`${pgURL}/prepare`, { EdiDate, Amt }).then(getData);

const postPaymentApproval = ({ returnUrl, form }) =>
    axios.post(returnUrl, form).then(getData);

const cancelVBank = () => axios.post(`${pgURL}/cancel_vbank`).then(getData);

const cancelTransferReq = ({ accountId, depositCreditsReqId }) =>
    axios
        .delete(`${baseURL}/transfers`, {
            data: { accountId, depositCreditsReqId },
        })
        .then(getData);

export default {
    purchaseCreditsByWire,
    purchaseCreditsByCard,
    uploadBusinessNoFile,
    getCreditsHistories,
    deleteBusinessNoFile,
    getPgPrepared,
    postPaymentApproval,
    cancelVBank,
    cancelTransferReq,
};
